import React, { useContext, useEffect } from 'react'
import { ContentFooter } from '../../layout/Content'
import RecordNavigator from '../../layout/RecordNavigator'
import ProductsListFooterStyle from './css/ProductsListFooterStyle'
import { productsListControllerContext } from './ProductsListController'

function ProductsListFooter() {
  const productsListController = useContext(productsListControllerContext)
  const { getTotalRecords, totalPage, setAllCheck, warehouses } = productsListController
  const [warehouse, setWarehouse] = productsListController.warehouse
  const [recordPerPage, setRecordPerPage] = productsListController.recordPerPage
  const [recPP, setRecPP] = productsListController.recPP
  const [page, setPage] = productsListController.page
  const setSelectAll = productsListController.selectAll[1]

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    totalPage, getTotalRecords
  }

  useEffect(() => {
    setAllCheck(false)
    setSelectAll(false)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <ContentFooter>
      <div id="products-list-footer-container">
        <div className='warehouse-options-container'>
          <select
            onChange={(e) => setWarehouse({
              ...warehouse,
              name: e.target.value,
              id: warehouses.find(wh => wh.name === e.target.value)._id})}
            value={(warehouse) ? warehouse.name : undefined}>
            {
              (warehouses) ?
                warehouses.map(wh  => (
                  <option key={wh._id}>{wh.name}</option>
                ))
              : null
            }
          </select>
        </div>
        <RecordNavigator { ...recordNavigatorProps }/>
      </div>
      <ProductsListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(ProductsListFooter)
